//웹앱개편 3차 신규 튜터 카드 컴포넌트
import classNames from 'classnames'
import Image from 'next/legacy/image'
import React from 'react'
import Badge from '../../components/common/Badge'
import ScheduleStatus from '../../components/student/ScheduleStatus'
import { s_tutors } from '../../modules/i18n/strings/auto/wording'
import useTranslation from '../../modules/i18n/useTranslation'
import { urlWidth } from '../../modules/utils'
import useScheduleStore from '../../store/useScheduleStore'

interface TutorCardNewProps {
  item: {
    is_mine: boolean
    name: string
    first_name: string
    school: string
    major: string
    image_url: string
    schedule_status: number
    teach_junior: boolean
    available_count_20: number
    available_count_40: number
    primary_keyword: string
    schedule_status_message_kr: string
    schedule_status_message_en: string
  }
  landing?: boolean
  currentUser?: { is_junior: boolean }
  className?: string
  onClickHeart?: (e: React.MouseEvent<HTMLDivElement>) => void
  handleAvatarClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}

const TutorCardNew = ({
  item,
  className,
  onClickHeart,
  handleAvatarClick,
  landing,
  currentUser,
}: TutorCardNewProps) => {
  const {
    is_mine,
    name,
    first_name,
    school,
    major,
    image_url,
    schedule_status,
    teach_junior,
    available_count_20,
    available_count_40,
    primary_keyword,
    schedule_status_message_kr,
    schedule_status_message_en,
  } = item

  const { t, isLocaleKO } = useTranslation()
  const currentCredit = useScheduleStore((state) => state.step1.currentCredit)

  return (
    <div
      className={classNames(
        className,
        'border-1 relative mb-6 cursor-pointer overflow-hidden rounded-md border-gray-100 bg-white shadow-sm hover:bg-gray-100',
        landing ? 'min-h-[300px]' : 'min-h-[335px]'
      )}
    >
      <div className="h-180 relative overflow-hidden bg-gray-200" onClick={handleAvatarClick}>
        <Image
          loading="lazy"
          className="h-[180px] object-cover"
          layout="fill"
          placeholder="empty"
          src={image_url ? urlWidth(image_url, 250) : ''}
          alt={''}
          unoptimized={true}
        />
      </div>

      {landing || (
        <div onClick={(e) => onClickHeart(e)} className="absolute top-0 right-0 m-16">
          <img
            alt="icon heart"
            src={is_mine ? '/assets/img/icons/icon-heart-active.svg' : '/assets/img/icons/icon-heart-inactive.svg'}
            className="max-w-none"
          />
        </div>
      )}

      <div onClick={handleAvatarClick} className="px-[12px] py-[16px] text-left">
        <div>
          <div className="text-16 mt-0 mb-0 text-left font-bold text-black">{name ? name : first_name}</div>
          <h5 className="text-14 m-0 truncate font-medium text-gray-700">{school}</h5>
          <div className="text-14 mb-[12px] truncate font-normal text-gray-500">{major}</div>
        </div>
        <div className="mt-3 text-left">
          {currentUser && currentUser.is_junior && !teach_junior && (
            <Badge style={{ fontSize: '14px', borderRadius: '5px' }} primary>
              {t(s_tutors.adults_only)}
            </Badge>
          )}
          {landing || (
            <ScheduleStatus
              available40={available_count_40}
              available20={available_count_20}
              scheduleStatus={schedule_status}
              currentCredit={currentCredit}
              message={isLocaleKO ? schedule_status_message_kr : schedule_status_message_en}
            />
          )}

          {landing || (
            <>
              <br />
              <Badge style={{ fontSize: '14px', borderRadius: '5px' }} blackLight clx="text-capitalize">
                {primary_keyword && `#${primary_keyword}`}
              </Badge>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default TutorCardNew
